$(window).scroll(function () {
  var st = $(window).scrollTop()
  //スマホ下部の固定メニュー
  if(st > 20) {
    $('#sp_menu_bottom').addClass('show');
  } else {
    $('#sp_menu_bottom').removeClass('show');
  }
  
  //商品ページのカートへのページ内リンクの表示
  if($('body').hasClass('template-product')){
    if(st > 200){
      $('a#tocart').addClass('active')
    }else{
      $('a#tocart').removeClass('active')
    }
  }
  
});

$(function(){

  //フッターのタブ（PC)
  $('footer .footerLink li').click(function(){
    var dt = $(this).data('footercategory')
    $(this).siblings('li').removeClass('on')
    $(this).addClass('on')
    $('footer .footerContent .blk').each(function(){
      if($(this).hasClass(dt)){
        $('footer .footerContent .blk').hide()
        $(this).show()
      }
    })
  })

  //トップページ　ランキングのスライダー
    $('.sec_ranking .col_titles .slider').slick({
        asNavFor: '.sec_ranking .ranking__slider',
        slidesToShow:3,
      focusOnSelect: true,
        arrows:true,
        dots:false,
        infinite:true,
      centerMode:true,
      responsive:[
            {
                breakpoint:768,
                slidesToShow:3,
              centerMode:true
            }
        ]
    })

    //トップページ　ランキングのスライダー（サムネイル）
    $('.sec_ranking .ranking__slider').slick({
        asNavFor: '.sec_ranking .col_titles .slider',
        slidesToShow:1,
        arrows:false,
        dots:false,
        infinite:true
    })

    //コーディネイトのスライダー
    $('.sec_coordinate .coordinates').slick({
        slidesToShow:3,
        autoplay:true,
        arrows:true,
        infinite:true,
        variableWidth:false,
        centerMode:false,
        responsive:[
          {
            breakpoint:768,
            settings:{
              slidesToShow:1
            }
          }
        ]
    })

    //トップページのバナーのスライダー
    $('.index-banners--slide').slick({
      slidesToShow:3,
      autoplay:true,
      dots:false,
      arrows:true,
      infinite:true,
      variableWidth:false,
      centerMode:false,
      responsive:[
        {
          breakpoint:768,
          settings:{
            centerMode:true,
            slidesToShow:1,
            centerPadding: '50px'
          }
        }
      ]
    })

    //グロナビ「カテゴリーから探す」のみクリック不能にする
    $('header a.site-nav__link--has-dropdown').on('click',function(){
      return false
    })

    //商品系ページのヘッダ下のバナースライダー
    $('.slider_banner .inner').slick({
      slidesToShow:3,
      autoplay:true,
      dots:true,
      arrows:true,
      infinite:true,
      variableWidth:false,
      centerMode:true,
      responsive:[
        {
          breakpoint:768,
          settings:{
            slidesToShow:1,
            centerMode:false,
            dots:false,
            arrows:false,
            autoplay:true,
            variableWidth:false
          }
        }
      ]
    })

    //コレクションページのタグフィルターの非表示
    let hidden_tag = ['配送希望日時指定不可']
    let els_filter_tag = document.querySelectorAll('#FilterDrawer li.tag')
    els_filter_tag.forEach(tag=>{
      if(hidden_tag.indexOf(tag.dataset.tagname) !== -1){
        tag.style.display = 'none'
      }
    })

    //検索結果ページのソートの初期表示
    let src_sort = location.search
    if(src_sort.indexOf('sort_by=') !== -1){
      let el_search_sort = document.querySelector('select#SortBy')
      if(src_sort.indexOf('sort_by=price-ascending') !== -1){
        el_search_sort.options[2].selected = true
      }
      if(src_sort.indexOf('sort_by=price-descending') !== -1){
        el_search_sort.options[3].selected = true
      }
    }

    product_detail_accordion_wrapping()
}) 

document.addEventListener('DOMContentLoaded',()=>{
  console.log('ready()')

  //商品詳細ページのスライダー
  let el_product_detail_image = document.querySelector('.js-swiper-product-images')
  if(el_product_detail_image){

    let swiper_thumb = new Swiper('.js-swiper-product-images-thumb', {
      loop: true,
      spaceBetween: 20,
      slidesPerView: 3.5,
      freeMode: true,
      watchSlidesProgress: true,
    })

    let swiper_main = new Swiper(el_product_detail_image, {
        loop: true,
        spaceBetween: 0,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: swiper_thumb,
        },
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        }
    })
  }

  //デフォルトテーマの商品画像（product-images.liquid）のサムネイルクリックでメイン画像を切り替え
  //モバイルではサムネイルスライダーがslickで初期化されないため、手動でクリックイベントを付与する
  //メイン画像はモバイルでもslickで初期化されているため、slickGoToでスライドを切り替える
  let $thumbSlider = $('.product__thumbs--beside');
  if($thumbSlider.length){
    $thumbSlider.on('click', '.product__thumb', function(e){
      e.preventDefault();
      let index = $(this).data('index');
      let $container = $thumbSlider.closest('[data-product-images]');
      let $mainSlider = $container.find('.product__main-photos').find('[id^="ProductPhotos-"]');

      if($mainSlider.hasClass('slick-initialized')){
        $mainSlider.slick('slickGoTo', index);
      } else {
        // slick未初期化時のフォールバック
        $mainSlider.find('[data-index]').removeClass('starting-slide').addClass('secondary-slide');
        $mainSlider.find('[data-index="' + index + '"]').removeClass('secondary-slide').addClass('starting-slide');
      }

      // サムネイルのアクティブ表示
      $thumbSlider.find('.product__thumb-item').removeClass('is-active');
      $(this).closest('.product__thumb-item').addClass('is-active');
    });
  }
})

//商品詳細を一部だけ見せ、ボタンで再表示する
function product_detail_accordion_wrapping(){
  console.log('product_detail_accordion_wrapping called')
  let search_element = document.querySelector('.product-single__description')
  if(search_element){
    // id="product-size" があればそれを基準にする。なければ img[src*="size.jpg"] を探す。
    const targetSizeTable = search_element.querySelector('#product-size');
    const targetImg = search_element.querySelector('img[src*="size.jpg"]');
    const baseElement = targetSizeTable || (targetImg ? (targetImg.closest('a') || targetImg) : null);

    if (baseElement) {
      // 2. search_element の直系の子要素まで遡る（pタグ等に囲まれている場合への対応）
      let topLevelSplitPoint = baseElement;
      while (topLevelSplitPoint && topLevelSplitPoint.parentElement !== search_element) {
        topLevelSplitPoint = topLevelSplitPoint.parentElement;
      }

      if (!topLevelSplitPoint) return; // 見つからない場合は終了

      console.log('topLevelSplitPoint:', topLevelSplitPoint)

      // 3. ラッピング用の新しい div を作成
      const wrapper = document.createElement('div');
      wrapper.classList.add('product-single__description-images'); // 任意のクラス名

      // 4. 最初の子要素から topLevelSplitPoint に到達するまで wrapper に移動
      // appendChild は「元の場所から削除して移動」する特性があるため、ループで回せます
      while (search_element.firstChild && search_element.firstChild !== topLevelSplitPoint) {
        wrapper.appendChild(search_element.firstChild);
      }

      // 5. 基準点の直前に、完成した wrapper を挿入
      search_element.insertBefore(wrapper, topLevelSplitPoint);
      const btnHtml = '<button type="button" class="product-single__description-vmbtn btn_vm">続きを見る</button>';
      wrapper.insertAdjacentHTML('beforeend', btnHtml);

      // 7. ボタンにクリックイベントをつける
      const btn = wrapper.querySelector('.product-single__description-vmbtn'); // wrapper 内から取得
      if (btn) {
        btn.addEventListener('click', () => {
          wrapper.classList.add('is-open'); // クラスでグラデーションを消す用
          btn.style.display = 'none';      // ボタン自体を消す
        });
      }
      
      console.log('Wrapping complete');
    }
  }
}